import React from 'react';
import { Segmented, Input, Button, Popover, Switch, Space } from 'antd';
import {
  UnorderedListOutlined,
  PartitionOutlined,
  SearchOutlined,
  PlusSquareOutlined,
  MinusSquareOutlined,
  FullscreenOutlined,
  ControlOutlined,
} from '@ant-design/icons';

function ComponentToolbar({
  view,
  onView,
  q,
  onQ,
  onExpandAll,
  onCollapseAll,
  onFullscreen,
  density,
  onDensity,
  guides,
  onGuides,
  connector,
  onConnector,
}) {
  const settings = (
    <Space direction="vertical" style={{ width: 240 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Densidad</span>
        <Segmented
          size="small"
          value={density}
          onChange={onDensity}
          options={[
            { label: 'Cómoda', value: 'comoda' },
            { label: 'Compacta', value: 'dense' },
          ]}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Guías de jerarquía</span>
        <Switch size="small" checked={guides} onChange={onGuides} />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span>Conector del mapa</span>
        <Segmented
          size="small"
          value={connector}
          onChange={onConnector}
          options={[
            { label: 'Curvo', value: 'curvo' },
            { label: 'Escalón', value: 'escalon' },
          ]}
        />
      </div>
    </Space>
  );

  return (
    <Space wrap style={{ marginBottom: 12, width: '100%' }}>
      <Segmented
        value={view}
        onChange={onView}
        options={[
          { label: 'Lista', value: 'lista', icon: <UnorderedListOutlined /> },
          { label: 'Mapa', value: 'mapa', icon: <PartitionOutlined /> },
        ]}
      />
      <Input
        allowClear
        prefix={<SearchOutlined />}
        placeholder="Buscar componente…"
        value={q}
        onChange={(e) => onQ(e.target.value)}
        style={{ flex: '1 1 180px', minWidth: 140, maxWidth: 280 }}
      />
      {view === 'lista' ? (
        <>
          <Button icon={<PlusSquareOutlined />} title="Expandir todo" onClick={onExpandAll} />
          <Button icon={<MinusSquareOutlined />} title="Colapsar todo" onClick={onCollapseAll} />
        </>
      ) : (
        <Button icon={<FullscreenOutlined />} title="Pantalla completa" onClick={onFullscreen}>
          Expandir
        </Button>
      )}
      <Popover content={settings} trigger="click" placement="bottomRight">
        <Button icon={<ControlOutlined />} title="Opciones de vista" />
      </Popover>
    </Space>
  );
}

export default ComponentToolbar;
